<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper *ngIf="!isLoading && connectionData && flightData">
    <div class="connection-wrapper">

        <ng-container *ngIf="connectionData.status === 'pending' ">
            <app-connection-request [request]="connectionData" [flightOption]="flightData"
                [isAccepting]="isHandlingAccept" [isDeclining]="isHandlingDecline"
                (acceptConnection)="handleAcceptConnection()"
                (declineConnection)="handleDeclineConnection()"></app-connection-request>
        </ng-container>

        <ng-container *ngIf="connectionData.status === 'accepted' ">
            <app-connection-chat [connection]="connectionData" [flightOption]="flightData"></app-connection-chat>
        </ng-container>

        <div class="canceled-wrapper"  *ngIf="connectionData.status === 'canceled' ">
            <app-icon-prompt-card iconURL="assets/svg/moon-solid.svg" label="Connection canceled"
                [header]="privateName"
                desc="Nothing to see here. This connection has been canceled."
                btnText="Go Back" btnRoute="/connections"></app-icon-prompt-card>
        </div>

    </div>
</app-page-wrapper>